import { forwardRef, useState, type InputHTMLAttributes } from "react";
import clsx from "clsx";

interface FgInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const FgInput = forwardRef<HTMLInputElement, FgInputProps>(function FgInput(
  { label, hint, error, className, id, ...props },
  ref,
) {
  const [focused, setFocused] = useState(false);
  const inputId = id ?? (label ? `fg-input-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="text-[11px] font-semibold uppercase tracking-wider text-[#8E8E93]"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        onFocus={(e) => {
          setFocused(true);
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          props.onBlur?.(e);
        }}
        className={clsx(
          "h-9 rounded-lg border bg-[#1C1C1E] px-3 text-sm text-[#FAFAFA] placeholder:text-[#8E8E93] transition-all duration-200 outline-none",
          error
            ? "border-[#FF453A] shadow-[0_0_0_3px_rgba(255,69,58,0.15)]"
            : focused
              ? "border-[#FFD60A] shadow-[0_0_0_3px_rgba(255,214,10,0.15)]"
              : "border-[rgba(255,255,255,0.1)] hover:border-[rgba(255,255,255,0.2)]",
          className,
        )}
        {...props}
      />
      {error ? (
        <p className="text-xs font-medium text-[#FF453A]">{error}</p>
      ) : hint ? (
        <p className="text-xs text-[#8E8E93]">{hint}</p>
      ) : null}
    </div>
  );
});
